module.exports = __webpack_public_path__ + "static/img/kk.0ec03f0d.png";